import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQzoneComponent } from './simple-icons-qzone.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQzoneComponent ],
    exports:      [ SimpleIconsQzoneComponent ],
    bootstrap:    []
})
export class SimpleIconsQzoneModule {}
